import React, { useCallback, useMemo } from 'react'
import { Row, Col } from 'react-grid-system'
import Dropdown from '../../common/form/fields/dropdown/dropdown'
import { WarehouseTransferViewProps } from '../actionsWorkflow.type'
import { Option } from '../../common/form/fields/dropdown/types'
import { convertWarehouseOptionToOption } from '../../common/crudItems/inventory/helpers'
import { Input } from '../../common/form/fields'

export const WarehouseTransferView = ({
   validationErrors,
   handleDropdownChange,
   handleCommentChange,
   warehouseOptions,
   selectedTransferToWarehouseOption,
}: WarehouseTransferViewProps) => {
   const handleLocationChange = useCallback(
      (option: Option) => handleDropdownChange('Location', option),
      [handleDropdownChange]
   )

   const options = useMemo(
      () =>
         warehouseOptions?.length > 0
            ? warehouseOptions.map(convertWarehouseOptionToOption)
            : [],
      [warehouseOptions]
   )

   const handleCommentFieldChange = useCallback(
      (comment) => handleCommentChange('Comment', comment),
      [handleCommentChange]
   )

   return (
      <Row gutterWidth={20}>
         <Col md={6} lg={6}>
            <Dropdown
               error={validationErrors?.NewLocation}
               name="NewLocation"
               onChange={handleLocationChange}
               defaultValue={selectedTransferToWarehouseOption}
               options={options}
               id="NewLocation"
               label="NewLocation"
               placeholder="New Location"
               isMulti={false}
               required
               menuPosition="fixed"
            />
         </Col>
         <Col md={6}>
            <Input
               id="Comment"
               label="Comment (optional)"
               onChange={handleCommentFieldChange}
            />
         </Col>
      </Row>
   )
}
